import { SummaryHeader } from 'V2Components'
import { EditIntegrationModal } from 'features/integrations'
import { getRsrcIcon } from 'features/resources'
import { getHTMLDataTestID } from 'infra/utils'
import { Button } from 'procyon-ui'
import React, { useState } from 'react'
import { useParams } from 'react-router'

const Header = ({ setShowDeleteModal, isJiraConfigEditable, integration }) => {
  const [showEditSlackButton, setSetShowEditSlackButton] = useState(false)

  //@ts-ignore
  const { integrationName, kind } = useParams()

  return (
    <div className='-mx-4 -mt-5 p-4'>
      <SummaryHeader
        Icon={getRsrcIcon(kind)}
        rsrcName={integrationName}
        actions={
          <div className='flex gap-4'>
            {integration.ObjectMeta.Kind === 'SlackIntegration' && (
              <Button
                data-testid={getHTMLDataTestID('integration', 'button', 'edit')}
                size='md'
                variant='grayBlue'
                onClick={() => setSetShowEditSlackButton(true)}
              >
                Edit
              </Button>
            )}
            <Button
              data-testid={getHTMLDataTestID('integration', 'button', 'remove')}
              size='md'
              variant='grayRed'
              onClick={() => setShowDeleteModal(true)}
            >
              Remove
            </Button>
          </div>
        }
        breadCrumbsItems={[
          {
            label: 'Integrations',
            link: '/admin/integrations'
          },
          kind === 'JiraIntegration'
            ? {
                label: integrationName,
                link: `/admin/integrations`
              }
            : {
                label: integrationName,
                link: '/admin/integrations'
              },
          isJiraConfigEditable && {
            label: 'Jira Config'
          }
        ]}
      />
      {showEditSlackButton && (
        <EditIntegrationModal
          onCancel={() => setSetShowEditSlackButton(false)}
          integ={integration}
        />
      )}
    </div>
  )
}

export { Header }
